"use client";

import { useCallback } from "react";
import HeaderLogo from "./HeaderLogo";
import MobileNavbar from "./MobileNavbar";
import { routes } from "@/lib/utils/routes";
import { useAppDispatch } from "@/lib/store";
import TopRightHeader from "./TopRightHeader";
import { useRouter } from "next-nprogress-bar";
import { useTranslation } from "@/i18n/client";
import SearchComponent from "./SearchComponent";
import Button from "@/components/common/shared/Button/button";
import { setActiveSidebar } from "@/lib/store/reducers/uiState";

const CenterHeaderPart = ({ tokenCipher, topTierItems }) => {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const { t } = useTranslation(["header", "common"]);

  const handleRedirect = useCallback(() => {
    router.push("/"); // Replace with your destination URL
  }, [router]);

  const openSidebar = () => {
    document.body.style.overflow = "unset";
    dispatch(setActiveSidebar(true));
  };

  return (
    <div className="centerHeaderPart">
      <div className="container">
        <div className="row lg:h-auto">
          <div className="col w-12/12">
            <div className="flex items-center justify-between xs:pb-0 pb-[76px] relative xs:min-h-max min-h-[128px]">
              <div className="leftPart">
                <div className="relative">
                  <Button
                    icon="menu"
                    theme="iconOnly"
                    onClick={openSidebar}
                    onTouchEnd={openSidebar}
                    onTouchStart={openSidebar}
                    className="me-12 lg:hidden block p-1"
                  />
                </div>
                <HeaderLogo handleRedirect={handleRedirect} />
                <SearchComponent t={t} routes={routes} router={router} />
              </div>
              <TopRightHeader
                t={t}
                routes={routes}
                router={router}
                dispatch={dispatch}
                tokenCipher={tokenCipher}
              />
            </div>
          </div>
        </div>
        <MobileNavbar navLinks={topTierItems} />
      </div>
    </div>
  );
};

export default CenterHeaderPart;
